export default __webpack_public_path__ + "static/media/image3.6089a376.png";